import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function subOfficialDocumentsReducer() {
    return combineReducers({
        OfficialDocuments_ListSubForPO: createItemReducer("SubOfficialDocuments", "PersJobDescExam.ListForSubForNewPO", false),
        OfficialDocuments_ListSubForPOParams: createItemReducerParams("SubOfficialDocuments", "PersJobDescExam.ListForSubForNewPO"),
        PersJobDescExam_ListASForSubForNewPO: createItemReducer("SubOfficialDocuments", "PersJobDescExam.ListASForSubForNewPO", false),
        PersJobDescExam_ListASForSubForNewArcPO: createItemReducer("SubOfficialDocuments", "PersJobDescExam.ListASForSubForNewArcPO", false)
    });
}